package navigation.home.proposal.proposal

import cafe.adriel.voyager.core.model.StateScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.features.area.domain.repository.AreaRepository
import com.essntl.features.category.domain.repository.CategoryRepository
import com.essntl.features.file.domain.repository.FileRepository
import com.essntl.features.profile.domain.use_case.GetCurrentUserUseCase
import com.essntl.features.proposal.domain.repository.ProposalRepository
import com.essntl.features.proposal.ui.proposalhistory.ProposalOverviewEvent
import com.essntl.features.proposal.ui.proposalhistory.ProposalOverviewState
import com.essntl.features.proposal.ui.proposalhistory.ProposalOverviewViewModel

class ProposalOverviewScreenModel(
    proposalRepository: ProposalRepository,
    areaRepository: AreaRepository,
    categoryRepository: CategoryRepository,
    getCurrentUserUseCase: GetCurrentUserUseCase,
    fileRepository: FileRepository,
    loadingManager: LoadingManager,
) : StateScreenModel<ProposalOverviewState>(ProposalOverviewState()) {

    private val vm = ProposalOverviewViewModel(
        proposalRepository = proposalRepository,
        areaRepository = areaRepository,
        categoryRepository = categoryRepository,
        fileRepository = fileRepository,
        getCurrentUserUseCase = getCurrentUserUseCase,
        scope = screenModelScope,
        state = mutableState,
        loadingManager = loadingManager,
    )

    fun onEvent(event: ProposalOverviewEvent) = vm.onEvent(event)
}
